import { render, staticRenderFns } from "./menuGuncelle.vue?vue&type=template&id=ce35feb0&scoped=true&"
import script from "./menuGuncelle.vue?vue&type=script&lang=js&"
export * from "./menuGuncelle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce35feb0",
  null
  
)

export default component.exports